import React from 'react';
import AuctionDetail from '../../components/feature/auction-detail/index';
import { Helmet } from 'react-helmet';

const AuctionDetails = () => {
    return (
        <React.Fragment>
            <Helmet>
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            </Helmet>
            <AuctionDetail />
        </React.Fragment>
    );
};

export default AuctionDetails;
